import {
  IProductType,
  IProductTypeListMode,
  IProductTypeOverview,
  IUpsellProductType,
  PRODUCT_TYPE_STRUCTURE_TYPES,
} from '@cakeiteasy/web-utils';

import { CART_LINE_TYPES } from '../constants/common';
import { ICakeCartLine } from '../models/cart/i-cake-cart-line';

type ProductTypeWithStructure =
  IProductType |
  IProductTypeListMode |
  IProductTypeOverview |
  IUpsellProductType |
  ICakeCartLine['productType'];

const BUILDER_STRUCTURE_TYPES = [
  PRODUCT_TYPE_STRUCTURE_TYPES.COMPLEX,
  PRODUCT_TYPE_STRUCTURE_TYPES.PIECES_GROUP,
  PRODUCT_TYPE_STRUCTURE_TYPES.PIECES,
  PRODUCT_TYPE_STRUCTURE_TYPES.CATERING_MENU,
];

export function getOrderLineBuilderStructureType(
  line: ICakeCartLine,
  productType?: ProductTypeWithStructure,
): string {
  return productType?.structureType ||
    line.productType?.structureType ||
    line.product?.type?.structureType;
}

export function canHaveOrderLineBuilderId(
  line: ICakeCartLine,
  productType?: ProductTypeWithStructure,
): boolean {
  if (!line || line.isCustom || line.details?.applyOnce) {
    return false;
  }

  if (line.type && line.type !== CART_LINE_TYPES.PRODUCT) {
    return false;
  }

  const structureType = getOrderLineBuilderStructureType(line, productType);
  if (BUILDER_STRUCTURE_TYPES.indexOf(structureType as any) === -1) {
    return false;
  }

  return !line.parentType || (
    productType?.structureType === PRODUCT_TYPE_STRUCTURE_TYPES.CATERING_MENU &&
    productType.id === line.parentType
  );
}
